<template>
    <div class="dataB-addGroup">
        <div class="form-group">
            <label>目录名称</label>
            <el-input v-model="form.name"></el-input>
        </div>
        <div class="btn-group">
            <span class="sure-btn" @click="handleSubmit">确定</span>
            <span class="cancel-btn" @click="handleCancel">取消</span>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        extr: {
            type: [Object],
        },
    },
    data() {
        return {
            form: {
            },
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 新增
        handleSubmit() {
            const data = this.form;
            data.parent_id = this.extr.parent_id;
            if (this.extr.handleType === 1) {
                this.$axios
                    .post('/interfaceApi/datacenter/interface/directory/save', data)
                    .then(res => {
                        if (res) {
                            this.$message.success('添加成功');
                            this.extr.callBackFn();
                            window.hideToast();
                        }
                    })
                    .catch(error => {
                        this.$message.error(error.ErrorCode.Message);
                    });
            } else {
                this.$axios
                    .post('/interfaceApi/datacenter/interface/directory/save', data)
                    .then(res => {
                        if (res) {
                            this.$message.success('修改成功');
                            this.extr.callBackFn();
                            window.hideToast();
                        }
                    })
                    .catch(error => {
                        this.$message.error(error.ErrorCode.Message);
                    });
            }

        },
        // 取消
        handleCancel() {
            window.hideToast();
        },
    },
    created() {
        const handleType = this.extr.handleType;
        if (handleType === 2) {
            const node = JSON.parse(JSON.stringify(this.extr.node));
            this.form = node;
        }
    },
    mounted() {},
};
</script>
<style lang="stylus" scoped>
.dataB-addGroup
    padding 30px 40px
    .form-group
        overflow hidden
        margin-bottom 20px
        label
            width 150px
            float left
            line-height 36px
            height 36px
        .el-input
            width calc(100% - 150px)
            float left
        .el-textarea
            width calc(100% - 150px)
            float left
    .tips
        font-size 13px
        margin-top 40px
        .tit
            .icontishi
                color #EB656F
                font-size 13px
                margin-right 10px
            .text
                color #333333
        .info
            margin-top 10px
            color #979EA7
            p
                line-height 24px
    .btn-group
        position absolute
        left 0
        bottom 20px
        width 100%
        text-align center
        .sure-btn
            width 180px
            height 40px
            background rgba(21,119,210,1)
            color #ffffff
            text-align center
            line-height 40px
            display inline-block
            margin-right 20px
            cursor pointer
        .cancel-btn
            width 180px
            height 40px
            border 1px solid rgba(21,119,210,1)
            color rgba(21,119,210,1)
            text-align center
            line-height 40px
            display inline-block
            box-sizing border-box
            cursor pointer
</style>